import { useRef } from 'react'

// We like to use react-hooks/exhaustive-deps because it's a best practice to catch subtle bugs/footguns.
// But in rare cases, you intentionally want to consume a stale value, so this helps satisfy the lint rule.
// "this is unadvisable" - Dan Abramov https://github.com/facebook/react/issues/14920#issuecomment-471070149
export const usePossiblyStaleValue = value => {
  const ref = useRef(value)

  return ref.current
}
